export default "__VITE_ASSET__BK0T0F8a__"